var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between"},[_c('h1',{staticClass:"page-header"},[_vm._v(_vm._s(_vm.$t('promotion.pageTitle')))]),_c('ts-breadcrumb',{attrs:{"items":[
      { text: _vm.$t('home'), href: '/' },
      {
        text: _vm.$t('promotion.pageTitle'),
        href: '/admin/promotions',
      },
      {
        text: _vm.$t('edit'),
        active: true,
      },
    ]}})],1),_c('ts-card',[_c('ts-card-wrapper',[_c('ts-loading-banner',{attrs:{"loading":_vm.loading}},[_c('a-tabs',{attrs:{"default-active-key":"5"}},[_c('a-tab-pane',{key:"5",attrs:{"tab":_vm.$t('promotion.freeItemPerAmount')}},[_c('IncentiveByItemForm',{ref:"incentiveByItemForm"})],1)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }